// StyledComponents.js
import { Card, Avatar, Typography, TableCell } from '@mui/material';
import { styled } from '@mui/system';

// GradientCard component with dynamic start and end colors for the gradient
export const GradientCard = styled(Card)(({ startcolor, endcolor, width = '70%' }) => ({
  background: `linear-gradient(180deg, ${startcolor}, ${endcolor})`,
  borderRadius: '20px',
  border: '3px solid black',
  boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.2)',
  display: 'flex',
  alignItems: 'center',
  padding: '16px',
  width: width,
  margin: '0 auto',
}));

// RoundedImage component with fixed dimensions and rounded corners
export const RoundedImage = styled(Avatar)({
  width: '100px',
  height: '100px',
  borderRadius: '25%',
});


export const HeaderTypography = ({ headerName, sx }) => (
  <Typography
      sx={{
          m: 1,
          fontFamily: '"Press Start 2P", sans-serif',
          fontWeight: 'bold',
          color: 'white',
          textShadow: '2px 2px 4px rgba(0, 0, 0, 0.5)',
          textTransform: 'uppercase',
          fontSize: {
              xs: '0.4rem',
              sm: '0.65rem',
              md: '0.775rem',
          },
          ...sx
      }}
  >
      {headerName}
  </Typography>
);

export const RecordTableCell = ({ recordValue, backgroundColor = 'white', sx }) => (
  <TableCell align="center" sx={{ backgroundColor, fontWeight: 'bold', ...sx }}>
    {recordValue}
  </TableCell>
);
